import { useState } from 'react';
import { setAlert } from '../../../redux/actions';
import { useDispatch } from 'react-redux';

const CreatorSalesBoostRefund = () => {
    const dispatch = useDispatch();

    const [planId, setPlanId] = useState('');
    const [busy, setBusy] = useState(false);

    const handleRefund = () => {
        setBusy(true);
        axios.post('/api/administration/creator-sales-boost/refund', {
            plan_id: planId
        })
            .then(response => {
                dispatch(setAlert({
                    type: 'success',
                    show: true,
                    body: 'Refund completed'
                }));
                setBusy(false);
            });
    };

    return <div className='d-flex'>
        <div className="mr-2">Plan ID</div>
        <div className="mr-2">
            <input
                id="planId"
                className="form-control form-control-sm"
                value={planId}
                onChange={(e) => setPlanId(e.target.value)}
            />
        </div>
        <div className=''>
            <button
                type="button"
                className="btn btn-primary btn-rounded btn-sm"
                disabled={busy || planId.length <= 0}
                onClick={handleRefund}
            >{
                    !busy ? 'Submit' : 'Processing...'
                }</button>
        </div>
    </div>;
};

export default CreatorSalesBoostRefund;